<span :class="className">{{ getModel }}</span>